/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon16Light = forwardRef('ArrowShapeADownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.117 14.573a1.25 1.25 0 0 0 1.768 0l5.866-5.866c.63-.63.184-1.707-.707-1.707H12V2.5A1.5 1.5 0 0 0 10.5 1h-5A1.5 1.5 0 0 0 4 2.5V7H1.958C1.067 7 .62 8.077 1.25 8.707l5.867 5.866Zm1.06-.707a.25.25 0 0 1-.353 0L1.958 8H4.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 0 .5.5h2.544l-5.866 5.866Z" })));
});
